import type { CSSProperties, ReactElement } from 'react'
import styles from './LineBadge.module.css'

export interface LineBadgeProps {
  /** Up-to-3-char line code, e.g. "CEN". Rendered boldPx8 white. */
  readonly label: string
  /** Hex color of the line. Pill background. DATA, not a token. */
  readonly hexColor: string
  /** Optional line_id passthrough for test/debug selectors. */
  readonly lineId?: string
}

/**
 * Compact line-code pill (Figma spec §1.7). `padding: 2 4`, `r 2`, fill =
 * line hex, label `boldPx8` white with `letter-spacing 0.16`,
 * `whitespace-nowrap`. One per line on a route variant.
 */
export function LineBadge({ label, hexColor, lineId }: LineBadgeProps): ReactElement {
  const style: CSSProperties = { backgroundColor: hexColor }
  return (
    <span className={styles.badge} style={style} data-line-id={lineId} data-testid="line-badge">
      {label}
    </span>
  )
}
